import { Spacer, Skeleton } from "@aviary";
import { useBreakpoints } from "@shared/hooks";

import * as styles from "./EditPasswordForm.styles";

const SkeletonEditPasswordForm = () => {
  const { tablet } = useBreakpoints();

  return (
    <>
      <Skeleton type="button" isFullwidth />
      <Spacer height="one" />
      <Skeleton type="button" isFullwidth />
      <Spacer height="one" />
      <div css={styles.alignCenter}>
        <Skeleton type="button" isFullwidth={!tablet.greaterThan} />
      </div>
    </>
  );
};

export { SkeletonEditPasswordForm };
